export default "__VITE_ASSET__mrWU0ju6__"